<template>
	<div>
		<agreement class="markdown-body">
		</agreement>
	</div>

</template>

<script>
	import 'github-markdown-css';
	// import privacy from '../../README.md'
	import agreement from '../assets/md/service-agreement.md'
	export default {
		name: "ServiceAgreement",
		data() {
			return {
			};
		},
		components:{
			agreement
		},
		// mounted() {
		// 	this.htmlMD = require(`../assets/md/privacy-policy.md`);
		// },
		methods: {

		}
	}
</script>

<style>
	* {
		box-sizing: border-box;
	}
</style>
